﻿export enum FileDeliveryType {
    Undefined = 0,
    Upload = 1,
    Email = 2
}